module.exports = __webpack_public_path__ + "img/5_day_tee.b7b45204.svg";